const files = require.context('.', false, /\.(jpg|jpeg|png|svg)$/)
const modules = {}
files.keys().forEach((key) => {
     if (key === './index.js') return
     modules[key.replace(/(\.\/|\.(jpg|jpeg|png|svg))/g, '')] = files(key)
})
export default modules